import type { LibraTicket } from 'features/libra/ticket/libraTicketsApi'

import type { LifecycleConfig, LifecycleStage } from './lifecycleTypes'

export function getLifecycleStage(
  ticket: LibraTicket,
  config?: LifecycleConfig
): LifecycleStage | undefined {
  if (!config || !ticket.ticketStatus) return undefined
  return config.stages.find((s) => s.id === ticket.ticketStatus)
}

export function isTerminalStage(
  ticket: LibraTicket,
  config?: LifecycleConfig
): boolean {
  const stage = getLifecycleStage(ticket, config)
  if (stage) return stage.terminal ?? false
  return ticket.workflowComplete
}
